import React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { useAuth } from '@modmd/data'
import { Container } from 'components/Layout'
import { PersonalPageLayout } from 'client-portal/components/PageLayout'
import { SessionDetail } from 'sharedComponents/SessionDetail'
import { ROUTES, PERSONAL_ROUTES } from 'client-portal/constants/routes'

interface RouterProps {
  testSessionId: string
}

type Props = RouteComponentProps<RouterProps>

export const PersonalTestSessionDetails: React.FC<Props> = ({ match }) => {
  const { testSessionId } = match.params
  const { data } = useAuth()

  return (
    <PersonalPageLayout>
      <Container>
        <SessionDetail
          userId={data.User.id}
          testSessionId={testSessionId}
          goBackPath={`/${ROUTES.PERSONAL}/${PERSONAL_ROUTES.SESSIONS}`}
          participantOnly
          isOrderVisible
          isEditable
        />
      </Container>
    </PersonalPageLayout>
  )
}
